import fun from "../../../util/util";
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import Axios from "../../../axios"
import {Message} from "element-ui";

export default {
    namespaced: true,
    state: {

        //控制和告警弹窗模块
        showControl: false,// 控制弹框是否显示的变量
        showWarningCenter: false,//控制告警弹窗是否显示的变量
        devTypeList:[], //弹窗的设备类型列表(左侧菜单列表)
        id: {
            stationId: "",//电站id
            devId: "",//设备id
        },
    },
    mutations: {
        
        //打开控制窗-新版本
        openControlNew(state, obj) {
            state.id.stationId = obj.stationId
            state.id.devId = obj.devId
            state.devTypeList = obj.list
            if(!fun.isNull(state.devTypeList) && state.devTypeList.length > 0){
                state.showControl = true
            }
        },
        //关闭控制窗
        closeControl(state) {
            state.showControl = false
            state.id.stationId = ""
            state.id.devId = ""
        },
        //打开告警窗
        openWarning(state) {
            state.showWarningCenter = true
        },
        //关闭告警窗
        closeWarning(state) {
            state.showWarningCenter = false
        },

    },

    actions:{
       getDevTypeList(context,obj){
            let params = {
                stationId: obj.stationId,
                devId: obj.devId
            };
            Axios.get(myApi.getStaDevAndTypeList, {params}).then((res) => {
                if (res.data.code === myConst.code.success) {
                    //如果返回的数据长度大于0时,弹窗才弹出
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((item) => {
                            item.active = false; //添加控制菜单展开还是收起的变量
                            item.icon = fun.isNull(item.icon) ? "icon-guangfu" : item.icon; //如果没有传入了icon图标,则显示默认的图标
                            item.value.forEach((sonItem) => {
                            sonItem.twoSelect = false; //添加二级菜单每一项的选中状态
                            });
                        });
                        context.commit("openControlNew",{
                                                            stationId:obj.stationId,
                                                            devId: obj.devId,
                                                            list: res.data.data
                                                        })
                    } else {
                        context.commit("openControlNew",{
                            stationId:obj.stationId,
                            devId: obj.devId,
                            list: res.data.data
                        })
                        // Message({message: res.data.msg, type: "info"})
                    }

                } else {
                    context.commit("openControlNew",{
                        stationId:obj.stationId,
                        devId: obj.devId,
                        list: res.data.data
                    })
                    // Message({message: res.data.msg, type: "info"})
                }
            }).catch(() => {
            });
       }
    }

}
